export default __webpack_public_path__ + "static/MediaContentTwo-89482728967841266b7fff22e2bb3cc1.webp";